module.exports = __webpack_public_path__ + "static/media/preview.c821bd1d.gif";